import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const estofexTutorial = (id, buttonText) => [
  {
    element: '.estofex_shortcut',
    intro: 'Tu nie ma niespodzianek. Możesz utworzyć skrót jak w przypadku SkyPredict.'
  },
  {
    element: '.estofex_framealpha',
    intro: 'Możesz ustawić przezroczystość ramki poligonu'
  },
  {
    element: '.estofex_fillalpha',
    intro: `Ten suwak dokładnie tak samo jak w przypadku SP ustawia przezroczystość wypełnienia (środka) poligonu. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
